export default "__VITE_ASSET__DHsfQY6G__"